import { useState, useContext } from 'react';
import { IonContent, IonPage, IonGrid, IonRow, IonCol, IonInput, IonButton, useIonViewDidEnter, IonIcon } from '@ionic/react';
import axios from 'axios';
import Navbar from '../../components/Navbar';
import './styles.css';
import { AppContext } from "../../context/appContext";
import { ServerUrl, GetCurrentYear } from '../../constants';
import MonthlyTypeEnum from '../../enum/monthly-type-enum';
import { MonthlyDataHelper } from '../../services/monthly-data-helper';
import { arrowForwardCircle } from 'ionicons/icons';

const MonthNames = [
  "September",
  "October",
  "November",
  "December",
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August"
];

const Home: React.FC = () => {
  const { CurrentUser } = useContext(AppContext);
  const token = CurrentUser ? CurrentUser.token : null;
  const isEscWorks = CurrentUser ? CurrentUser.isEscWorks : false;
  const groupName = CurrentUser ? CurrentUser.group : '';

  const [MonthRowStates, SetMonthRowStates] = useState<Array<{ name: string, isEqualSum: boolean }>>([
    { name: "September", isEqualSum: true },
    { name: "October", isEqualSum: true },
    { name: "November", isEqualSum: true },
    { name: "December", isEqualSum: true },
    { name: "January", isEqualSum: true },
    { name: "February", isEqualSum: true },
    { name: "March", isEqualSum: true },
    { name: "April", isEqualSum: true },
    { name: "May", isEqualSum: true },
    { name: "June", isEqualSum: true },
    { name: "July", isEqualSum: true },
    { name: "August", isEqualSum: true }
  ]);

  const currentYear = GetCurrentYear() - 2000;
  let current_year = currentYear + '-' + (currentYear + 1);
  let previous_year = (currentYear - 1) + '-' + currentYear;

  const currentFullYear = GetCurrentYear();
  let current_full_year = currentFullYear + ' - ' + (currentFullYear + 1);
  let previous_full_year = (currentFullYear - 1) + ' - ' + currentFullYear;

  const dataUrl = `${ServerUrl}/monthly/2.1`;
  const totalSubmittedUrl = `${ServerUrl}/monthly/2.1/totalSubmitted`;

  const [CurrentData, SetCurrentData] = useState<Array<any>>([]);
  const [PreviousData, SetPreviousData] = useState<Array<any>>([]);

  const [TotalNonEscWorksSum, SetTotalNonEscWorksSum] = useState<string>('');
  const [TotalEscWorksDashboardSum, SetTotalEscWorksDashboardSum] = useState<string>('');
  const [CurrentSum, SetCurrentSum] = useState<string>('');
  const [PreviousSum, SetPreviousSum] = useState<string>('');

  useIonViewDidEnter(() => {
    LoadData();
  });

  const LoadData = () => {
    axios.get(`${dataUrl}?year=${current_year}`, {
        headers: {
          'Authorization': "Bearer " + token,          
        }
      }).then(res => {
        if (res.data && res.data.length > 0) {
          SetCurrentData(res.data);
          SetCurrentSum(getSum(res.data));
          SetTotalNonEscWorksSum(getSum(res.data, MonthlyTypeEnum.NonEscWorksData));
          SetTotalEscWorksDashboardSum(getSum(res.data, MonthlyTypeEnum.EscWorksDashboardData));
        
          setMonthRawStates(res.data);
        }
    }, err => {
      alert("Fail to get data. " + JSON.stringify(err))
    });

    axios.get(`${dataUrl}?year=${previous_year}`, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      if (res.data && res.data.length > 0) {
        SetPreviousData(res.data);
        SetPreviousSum(getSum(res.data));
      }
    }, err => {
      console.log("Fail to get data. " + JSON.stringify(err))
    });
  };

  const setMonthRawStates = (inititalData: Array<any>) => {
    const yearDataArray = inititalData.filter(element => element.year === current_year);
    yearDataArray.forEach(monthData => {
      updateMonthRowStates(monthData.month, current_year, monthData.nonEscWorksData, monthData.escWorksDashboardData, monthData.trainContactHours);
    });
  }

  const updateNonEscEorksData = (month: string, value: any, year: string, current: boolean, monthlyType: MonthlyTypeEnum) => {
    saveData(month, value, year, current, monthlyType);

    updateMonthRowStates(month, year, value);
  }

  const updateMonthRowStates = (month: string,  year: string, nonEscWorksValue: any, 
      escWorksDashboardValue: any = null, submittedValue: any = null) => {
    SetMonthRowStates(prevMonthState => {
      const newState = prevMonthState.map(prevMonth => {

        if (prevMonth.name == month) {
          return {...prevMonth, isEqualSum: MonthlyDataHelper.isSumEqual(CurrentData, month, year, nonEscWorksValue, escWorksDashboardValue, submittedValue)};
        }

        return prevMonth;
      });

      return newState;
    });
  }

  const getData = (dataArray: Array<any>, name: string, monthlyType: MonthlyTypeEnum = MonthlyTypeEnum.Default) => {
    let num = 0;
    let element = dataArray.find(e => e.month === name);
    if (element) {
      try {
        num = parseFloat(MonthlyDataHelper.getDataByMontlyType(element, monthlyType));
      }
      catch {}
    }

    return num;
  }

  const getSum = (data: Array<any>, monthlyType: MonthlyTypeEnum = MonthlyTypeEnum.Default): string => {
    let sum = 0;

    data.forEach(item => {
      let data = parseFloat(MonthlyDataHelper.getDataByMontlyType(item, monthlyType));
      if (!isNaN(data)) {
        sum += data;
      }
    });
      
    return sum === 0 ? sum.toString() : sum.toLocaleString();
  }

  const saveData = (month: string, value: any, year: string, current: boolean, monthlyType: MonthlyTypeEnum) => {
    axios.post(dataUrl, {"month": month, "value": value, "year": year, "monthlyType" : monthlyType}, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      if (current) {
        let currentItem = res.data.find((item: { month: string; year: string; }) => item.month === month && item.year === year);
        if (currentItem && monthlyType == MonthlyTypeEnum.Default) {
          currentItem.trainContactHours = value;
        }

        SetCurrentSum(getSum(res.data));
        SetCurrentData(res.data);
        SetTotalNonEscWorksSum(getSum(res.data, MonthlyTypeEnum.NonEscWorksData));
        SetTotalEscWorksDashboardSum(getSum(res.data, MonthlyTypeEnum.EscWorksDashboardData));
      }
      else {
        let currentItem = res.data.find((item: { month: string; year: string; }) => item.month === month && item.year === year);
        if (currentItem) {
          currentItem.trainContactHours = value;
        }

        SetPreviousSum(getSum(res.data));
        SetPreviousData(res.data);
      }
    });
  }

  const onSaveExcel = () => {
    axios.get(`${ServerUrl}/monthly/2.1a/excel?current=${current_year}&previous=${previous_year}`, {
      headers: {
        'Authorization': "Bearer " + token,          
      },
      responseType: 'blob',
    }).then(res => {
      const url = window.URL.createObjectURL(new Blob([res.data],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download','Monthly 2.1a.xlsx');
        document.body.appendChild(link);
        link.click();
    }); 
  }

  const updateSubmittedData = (month: string) => {
    const monthData = CurrentData.find(element => element.year === current_year && element.month == month);
    const floatEscWorksDashBoardValue = MonthlyDataHelper.tryParseFloat(monthData.escWorksDashboardData).parsedValue;
    const floatNonEscWorksValue = MonthlyDataHelper.tryParseFloat(monthData.nonEscWorksData).parsedValue;
    const updatedValue = floatEscWorksDashBoardValue + floatNonEscWorksValue

    axios.post(totalSubmittedUrl, {"month": month, "value": updatedValue, "year": current_year}, {
      headers: {
        'Authorization': "Bearer " + token,          
      }
    }).then(res => {
      SetCurrentData(res.data);
      SetCurrentSum(getSum(res.data));
      SetTotalNonEscWorksSum(getSum(res.data, MonthlyTypeEnum.NonEscWorksData));
      SetTotalEscWorksDashboardSum(getSum(res.data, MonthlyTypeEnum.EscWorksDashboardData));

      setMonthRawStates(res.data);
    })
  }
  
  return (
    <IonPage>
      <Navbar />
      <IonContent fullscreen>
        <div className='content-container'>
          <div className='contents'>
            <div style={{marginBottom: '10px', marginTop: '20px'}}>{groupName}</div>
            <div style={{marginBottom: '20px'}}>Indicator 2.1a - Training Contact Hours Delivered</div>          
            <IonButton color="primary" style={{textTransform:'none'}} onClick = {onSaveExcel}>Export to Excel</IonButton>
            <IonGrid>
              <IonRow>
                <IonCol offset="4" size="8" className="no-border"><span>Training Contact Hours</span></IonCol>
              </IonRow>
              <IonRow>
                  <IonCol className='data-row no-border'></IonCol>
                  <IonCol style={{fontSize: '14px', display: 'none'}} className='data-row'>
                    <IonInput min='0'  value="Non-escWorks Data" readonly />
                  </IonCol>
                              <IonCol size="auto" style={{ fontSize: '14px', display: 'none' }} className='data-row'>
                    <IonInput style={{width: '180px'}} min='0' value="escWorks Dashboard Data" readonly />
                  </IonCol>
                  <IonCol style={{fontSize: '14px'}} className='data-row'>
                    <IonInput min='0'  value="Submitted Data" readonly />
                  </IonCol>
                  <IonCol style={{fontSize: '14px'}} className='data-row right-border'>
                    <IonInput min='0'  value="Prior Year" readonly />
                  </IonCol>
                </IonRow>
              <IonRow className="header-row">
                <IonCol className='data-row no-border'></IonCol>
                              <IonCol className='data-row table-header' style={{ display: 'none' }}>
                  <IonInput min='0'  value={current_full_year} readonly />
                </IonCol>
                              <IonCol size="auto" className='data-row table-header' style={{ display: 'none' }}>
                  <IonInput style={{width: '180px'}} min='0'  value={current_full_year} readonly />
                </IonCol>
                <IonCol className='data-row table-header'>
                  <IonInput min='0'  value={current_full_year} readonly />
                </IonCol>
                <IonCol className='data-row right-border table-header'>
                  <IonInput min='0'  value={previous_full_year} readonly />
                </IonCol>
              </IonRow>
              {
                MonthRowStates.map((state, index) => {
                  if (state.isEqualSum) {
                    return (
                      <IonRow key={index} className={(index % 2) === 0 ? "dark-row" : "light-row"}>
                        <IonCol className='data-row ion-text-center'>
                          <IonInput min='0'  value={state.name} readonly />
                        </IonCol>
                            <IonCol className='data-row' style={{ display: 'none' }}>
                          <IonInput min='0'  type="number" step="1" value={getData(CurrentData, state.name, MonthlyTypeEnum.NonEscWorksData)} placeholder="" onBlur={(e) => {
                              updateNonEscEorksData(state.name, e.target.value, current_year, true, MonthlyTypeEnum.NonEscWorksData);
                            }}>     
                          </IonInput>
                        </IonCol>
                            <IonCol size="auto" className='data-row' style={{ display: 'none' }}>
                          <IonInput style={{width: '180px'}} min='0' readonly  type="number" step="1" value={getData(CurrentData, state.name, MonthlyTypeEnum.EscWorksDashboardData)} placeholder="" onBlur={(e) => {
                              //saveTotalData(name, e.target.value, current_year, true);
                            }}>     
                          </IonInput>
                        </IonCol>
                        <IonCol className='data-row'>
                          <IonInput min='0'  type="number" step="1" value={getData(CurrentData, state.name)} placeholder="" onBlur={(e) => {
                              saveData(state.name, e.target.value, current_year, true, MonthlyTypeEnum.Default)
                            }}>     
                          </IonInput>
                        </IonCol>
                        <IonCol className='data-row right-border'>
                          <IonInput min='0'  readonly type="number" step="1" value={getData(PreviousData, state.name)} placeholder="" onBlur={(e) => {
                              //saveData(state.name, e.target.value, previous_year, false, MonthlyTypeEnum.TrainContactHours)
                            }}>    
                          </IonInput>
                        </IonCol>                        
                      </IonRow>
                    )
                  }
                  else{
                    return (
                      <IonRow key={index}>
                        <IonCol className='data-row ion-text-center'>
                          <IonInput min='0'  value={state.name} readonly />
                        </IonCol>
                            <IonCol className='data-row highlighted-row' style={{ display: 'none' }}>
                          <IonInput min='0'  type="number" step="1" value={getData(CurrentData, state.name, MonthlyTypeEnum.NonEscWorksData)} placeholder="" onBlur={(e) => {
                              updateNonEscEorksData(state.name, e.target.value, current_year, true, MonthlyTypeEnum.NonEscWorksData);
                            }}>     
                          </IonInput>
                        </IonCol>
                            <IonCol size="auto" className='data-row highlighted-row' style={{ display: 'none' }}>
                          <IonInput style={{width: '180px'}} min='0' readonly  type="number" step="1" value={getData(CurrentData, state.name, MonthlyTypeEnum.EscWorksDashboardData)} placeholder="" onBlur={(e) => {
                              //saveTotalData(name, e.target.value, current_year, true);
                            }}>     
                          </IonInput>
                          <IonButton fill="clear" onClick={() => updateSubmittedData(state.name)} className="arrow-button">
                            <IonIcon icon={arrowForwardCircle} />
                          </IonButton>
                        </IonCol>
                        <IonCol className='data-row highlighted-row'>
                          <IonInput min='0'  type="number" step="1" value={getData(CurrentData, state.name)} placeholder="" onBlur={(e) => {
                              saveData(state.name, e.target.value, current_year, true, MonthlyTypeEnum.Default)
                            }}>     
                          </IonInput>
                        </IonCol>
                        <IonCol className='data-row right-border'>
                          <IonInput min='0'  readonly type="number" step="1" value={getData(PreviousData, state.name)} placeholder="" onBlur={(e) => {
                              //saveData(state.name, e.target.value, previous_year, false, MonthlyTypeEnum.TrainContactHours)
                            }}>    
                          </IonInput>
                        </IonCol>                        
                      </IonRow>
                    )
                  }
                })
              }
              <IonRow>
                <IonCol className='data-row top-border'></IonCol>
                              <IonCol className='data-row bottom-border table-header foot-text-color' style={{ display: 'none' }}>
                  <div style={{paddingRight: '14px'}}>
                    <IonInput value={TotalNonEscWorksSum} readonly />
                  </div>
                </IonCol>
                              <IonCol size="auto" className='data-row bottom-border table-header foot-text-color' style={{ display: 'none' }}>
                  <div style={{paddingRight: '14px', width: '180px'}}>
                    <IonInput value={TotalEscWorksDashboardSum} readonly />
                  </div>
                </IonCol>
                <IonCol className='data-row bottom-border table-header foot-text-color'>
                  <div style={{paddingRight: '14px'}}>
                    <IonInput min='0'  value={CurrentSum} readonly />
                  </div>
                </IonCol>
                <IonCol className='data-row bottom-border right-border table-header foot-text-color'>
                  <div style={{paddingRight: '14px'}}>
                    <IonInput min='0'  value={PreviousSum} readonly />
                  </div>
                </IonCol>
              </IonRow>
            </IonGrid>
          </div>
        </div>
      </IonContent>
    </IonPage>
  );
};

export default Home;
